import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col space-y-2"
}
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = {
  key: 2,
  class: "flex flex-col space-y-2"
}
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}

import { computed, Ref } from "vue";
import { StatusCountry } from "@/interfaces/StatusCountry";
import { useMapThemeStore } from "@/store/useMapThemeStore";
import { Theme } from "@/interfaces/Theme";
import { useAuthStore } from "@/store/useAuthStore";
import { useMapStore } from "@/store/useMapStore";
import UnvisitedIcon from "@/components/Icons/UnvisitedIcon.vue";
import VisitedIcon from "@/components/Icons/VisitedIcon.vue";
import ToVisitIcon from "@/components/Icons/ToVisitIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GrayCaseForMenu',
  props: {
    status: {},
    countryCode: {},
    withText: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const authStore = useAuthStore();
const mapThemeStore = useMapThemeStore();

const theme: Ref<Theme> = computed(() => {
  if (authStore.currentUser) {
    return mapThemeStore.getThemeByName(authStore.currentUser.selectedTheme);
  } else {
    return mapThemeStore.themes[0];
  }
});

const themeStyle = computed(() => {
  switch (props.status) {
    case StatusCountry.Visited:
      return { backgroundColor: theme.value?.visited };
    case StatusCountry.ToVisit:
      return { backgroundColor: theme.value?.toVisit };
    case StatusCountry.Unvisited:
      return { backgroundColor: theme.value?.unvisited };
    default:
      return { backgroundColor: theme.value?.unvisited };
  }
});

const countryUser = computed(() => {
  return authStore.getCountryById(props.countryCode);
});

const active = computed(() => {
  return countryUser.value.status === props.status;
});

const mapStore = useMapStore();

const updateStatus = (status: StatusCountry) => {
  mapStore.updateCountryStatusByCode(props.countryCode, status);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["py-2", {
      'bg-custom-lightGray text-custom-darkGray': !active.value,
      'text-white': active.value,
    }]),
    style: _normalizeStyle(active.value ? themeStyle.value : ''),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (updateStatus(props.status))),
    onTouch: _cache[1] || (_cache[1] = ($event: any) => (updateStatus(props.status)))
  }, [
    (props.status === _unref(StatusCountry).Unvisited)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(UnvisitedIcon, { class: "w-3/12 md:w-2/12 mx-auto" }),
          (props.withText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Unvisited"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.status === _unref(StatusCountry).Visited)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(VisitedIcon, { class: "w-3/12 md:w-2/12 mx-auto" }),
          (props.withText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Visited"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.status === _unref(StatusCountry).ToVisit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(ToVisitIcon, { class: "w-3/12 md:w-2/12 mx-auto" }),
          (props.withText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "To Visit"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 38))
}
}

})